/**
 * This module contains the [[Show]] helper component used to conditionally render HTML.
 */

/***/
import { Scope } from './Scope';
import { Model } from '../Model';
import { Template } from '../view/Template';
import { View, create } from '../view/View';
import { observeProperties } from '../Observer';
import { Subscription } from '../Signal';

/**
 * A helper view that renders the contents of its node into the DOM only if some condition is true.
 *
 * ### Basic usage:
 *
 * ```html
 * <div view="show" if="[[someBooleanCondition]]">
 *   This is rendered only if `someBooleanCondition` evaluates to true.
 * </div>
 * ```
 */
export class Show extends View<ShowModel> implements Scope {

	private contentTemplate:Template;
	private dataSubscription:Subscription;

	constructor( ) {
		super( { template:'', data:{ if:true } } );
	}

	prepareContent( node:Element, template:Template ) {
		this.contentTemplate = new Template( node.innerHTML );
		node.innerHTML = '';
	}

	init() {
		this.checkVisibility();
		this.dataSubscription = observeProperties( this.data, 'if' ).propertyChange.filter( e => e.name == 'if' ).subscribe( this.checkVisibility.bind( this ) );
	}

	checkVisibility() {
		let n = this.contentTemplate.node;
		if( this.data.if ) {
			// check if its rendered
			if( !n ) {
				this.contentTemplate.context = this.template.context.parent;
				this.contentTemplate.render();
				n = this.contentTemplate.node;
			}
			this.node.appendChild( n );
		} else {
			n?.parentNode?.removeChild( n );
		}
	}

	deinit() {
		if( this.dataSubscription ) this.dataSubscription.unsubscribe();
	}
}


class ShowModel {
	if:boolean;
}
